<template>
  <div class="terms-content">
    <div class="terms-content-updated">Atualizado em 15 de julho de 2026</div>
    <div class="terms-content-body">
      <p>
        Estes Termos de Uso (“<strong class="text-primary">Termos</strong>”)
        regulam o acesso e a utilização do software
        STENCI (“<strong class="text-primary">Plataforma</strong>”),
        disponibilizado por STENCI TECNOLOGIA LTDA, pessoa jurídica de
        direito privado, inscrita no CNPJ sob nº 52.096.345/0001-94, com sede
        na Rua Fernando Amaro, 60, Alto da XV, Curitiba - PR, CEP 80045-080
        (“<strong class="text-primary">Empresa</strong>”).
      </p>

      <p>
        Ao acessar, contratar, cadastrar-se ou utilizar a Plataforma, o Cliente
        declara que leu, compreendeu e concorda integralmente com estes Termos
        e com a Política de Privacidade, disponível em
        <a href="https://stenci.app/privacy-policy"
           class="text-bold text-primary"
           target="_blank"
        >
          https://stenci.app/privacy-policy
        </a>.
      </p>

      <p>
        Caso não concorde com estes Termos, o uso da Plataforma deverá ser
        imediatamente interrompido.
      </p>

      <div class="h4 page-subtitle">1. Definições</div>

      <p>Para os fins deste instrumento, considera-se:</p>

      <ul>
        <li>
          <strong>Plataforma:</strong>
          software de gestão para clínicas e consultórios disponibilizado em
          ambiente web e/ou aplicativo.
        </li>
        <li>
          <strong>Cliente:</strong>
          pessoa física ou jurídica que contrata a Plataforma.
        </li>
        <li>
          <strong>Usuário:</strong>
          pessoa autorizada pelo Cliente a acessar a Plataforma.
        </li>
        <li>
          <strong>Paciente:</strong>
          pessoa cujos dados são inseridos e tratados pelo Cliente na
          Plataforma.
        </li>
        <li>
          <strong>Acessos Simultâneos:</strong>
          número máximo de dispositivos que podem estar logados e utilizando a
          Plataforma ao mesmo tempo, conforme o Plano contratado.
        </li>
        <li>
          <strong>Usuário Ativo:</strong>
          Usuário autenticado com sessão válida no sistema.
        </li>
        <li>
          <strong>Plano:</strong>
          conjunto de funcionalidades, limites técnicos e valores contratados.
        </li>
        <li>
          <strong>Conteúdo do Cliente:</strong>
          todos os dados e informações inseridos na Plataforma pelo Cliente
          ou seus Usuários.
        </li>
      </ul>

      <div class="h4 page-subtitle">2. Objeto</div>

      <p>
        <strong>2.1.</strong>
        A Plataforma tem por objetivo disponibilizar ferramentas de gestão
        administrativa, clínica e operacional para clínicas e consultórios,
        conforme funcionalidades contratadas.
      </p>

      <p>
        <strong>2.2.</strong>
        A Plataforma não substitui o julgamento clínico ou profissional do
        Usuário. Toda e qualquer decisão médica, administrativa ou financeira
        é de responsabilidade exclusiva do Cliente e dos profissionais
        responsáveis.
      </p>

      <div class="h4 page-subtitle">3. Aceite, cadastro e conta</div>

      <p>
        <strong>3.1.</strong>
        Para utilização da Plataforma, o Cliente deverá realizar cadastro
        fornecendo informações verdadeiras, completas e atualizadas.
      </p>

      <p>
        <strong>3.2.</strong>
        O Cliente é integralmente responsável:
      </p>

      <ul>
        <li>pela criação e gestão de Usuários;</li>
        <li>pela definição de permissões de acesso;</li>
        <li>pela guarda e confidencialidade das credenciais.</li>
      </ul>

      <p>
        <strong>3.3.</strong>
        O compartilhamento de login é proibido.
      </p>

      <div class="h4 page-subtitle">4. Planos, cobrança e acessos simultâneos</div>

      <p>
        <strong>4.1.</strong>
        A contratação da Plataforma ocorre mediante escolha de Plano disponível
        no momento da contratação.
      </p>

      <p>
        <strong>4.2.</strong>
        A cobrança é baseada exclusivamente no conjunto de funcionalidades e
        na quantidade de Acessos Simultâneos contratados, e não no número total
        de usuários cadastrados.
      </p>

      <p>
        <strong>4.3.</strong>
        O Cliente poderá cadastrar quantos Usuários desejar, desde que
        respeitado o limite de Acessos Simultâneos do Plano.
      </p>

      <p>
        <strong>4.4.</strong>
        Ao atingir o limite de Acessos Simultâneos:
      </p>

      <ul>
        <li>
          novos logins poderão ser automaticamente bloqueados até a liberação
          de uma sessão ativa; e/ou
        </li>
        <li>
          o sistema poderá solicitar o encerramento de uma sessão existente.
        </li>
      </ul>

      <p>
        <strong>4.5.</strong>
        Caso o Cliente necessite ampliar o número de Acessos Simultâneos,
        deverá contratar novo Plano ou solicitar upgrade, sujeito às condições
        comerciais vigentes.
      </p>

      <p>
        <strong>4.6.</strong>
        O Cliente é responsável por organizar seus fluxos internos de trabalho
        para respeitar o limite contratado.
      </p>

      <div class="h4 page-subtitle">5. Pagamento, reajustes e inadimplência</div>

      <p>
        <strong>5.1.</strong>
        Os valores e periodicidade (mensal ou anual) constam na proposta
        comercial ou área de assinatura da Plataforma.
      </p>

      <p>
        <strong>5.2.</strong>
        A cobrança é recorrente, mediante autorização do Cliente.
      </p>

      <p>
        <strong>5.3.</strong>
        Os valores poderão ser reajustados anualmente com base no IPCA ou outro
        índice que venha a substituí-lo, mediante comunicação prévia.
      </p>

      <p>
        <strong>5.4.</strong>
        Em caso de inadimplência superior a 30 dias, a Empresa poderá:
      </p>

      <ul>
        <li>suspender parcial ou totalmente o acesso à Plataforma;</li>
        <li>manter os dados pelo prazo definido neste Termo;</li>
        <li>restabelecer o acesso após regularização.</li>
      </ul>

      <div class="h4 page-subtitle">6. Política de Descontos por Volume</div>

      <p>
        <strong>6.1.</strong>
        A CONTRATADA poderá, a seu exclusivo critério, conceder descontos progressivos
        sobre os valores devidos pelo uso do sistema, com base na quantidade
        de licenças ativas contratadas pelo CONTRATANTE.
      </p>

      <p>
        <strong>6.2.</strong>
        A política de progressão de descontos, incluindo critérios, faixas de enquadramento
        e percentuais aplicáveis, será definida conforme as regras comerciais vigentes da
        CONTRATADA, sendo os percentuais eventualmente aplicáveis informados ao CONTRATANTE
        por meio da área do cliente dentro do sistema ou por outros canais oficiais, não
        integrando este contrato para fins de imutabilidade ou vinculação econômica.
      </p>

      <p>
        <strong>6.3.</strong>
        O enquadramento do CONTRATANTE em determinada faixa de desconto ocorrerá
        automaticamente, de acordo com a quantidade de licenças ativas no período
        de faturamento, podendo os descontos ser ajustados, suspensos ou revogados
        em caso de redução de licenças, inadimplência, alteração do plano contratado
        ou mudança na política comercial vigente.
      </p>

      <p>
        <strong>6.4.</strong>
        A concessão de desconto não gera direito adquirido, expectativa de
        permanência ou obrigação de manutenção futura, podendo a CONTRATADA
        revisar ou encerrar a política de descontos mediante comunicação prévia.
      </p>

      <div class="h4 page-subtitle">7. Uso adequado e condutas proibidas</div>

      <p>É vedado ao Cliente e aos Usuários:</p>

      <ul>
        <li>acessar áreas técnicas, código-fonte ou banco de dados;</li>
        <li>realizar engenharia reversa, cópia ou exploração da Plataforma;</li>
        <li>utilizar robôs, automações ou scraping sem autorização;</li>
        <li>
          inserir conteúdos ilícitos, maliciosos ou que violem direitos de
          terceiros;
        </li>
        <li>
          revender, sublicenciar ou disponibilizar a Plataforma a terceiros.
        </li>
      </ul>

      <p>
        O descumprimento poderá resultar em suspensão ou encerramento da conta.
      </p>

      <div class="h4 page-subtitle">8. Propriedade intelectual</div>

      <p>
        <strong>8.1.</strong>
        A Plataforma, incluindo código, layout, marcas, funcionalidades e
        documentação, é de propriedade exclusiva da Empresa.
      </p>

      <p>
        <strong>8.2.</strong>
        O Cliente recebe licença limitada, não exclusiva, intransferível e
        revogável para uso interno durante a vigência do contrato.
      </p>

      <p>
        <strong>8.3.</strong>
        O Conteúdo do Cliente permanece sob sua titularidade.
      </p>

      <div class="h4 page-subtitle">9. Dados pessoais e LGPD</div>

      <p>
        <strong>9.1.</strong>
        O tratamento de dados pessoais observará a Lei nº 13.709/2018 (LGPD) e
        a Política de Privacidade.
      </p>

      <p>
        <strong>9.2.</strong>
        O Cliente é o Controlador dos dados de seus pacientes. A Empresa atua
        como Operadora, tratando dados apenas para execução dos serviços.
      </p>

      <p>
        <strong>9.3.</strong>
        O Cliente declara possuir base legal para tratamento dos dados inseridos
        na Plataforma.
      </p>

      <div class="h4 page-subtitle">10. Integrações com terceiros (Google)</div>

      <p>
        <strong>10.1.</strong>
        A Plataforma oferece, de forma opcional, funcionalidades de
        tele atendimento e sincronização de agenda mediante integração com
        serviços do Google (Google Calendar e Google Meet), ativada
        exclusivamente por escolha do Usuário.
      </p>

      <p>
        <strong>10.2.</strong>
        Ao ativar essa integração, o Usuário autoriza o acesso da Plataforma
        a dados de sua conta Google, nos termos descritos na Política de
        Privacidade, disponível em
        <a href="https://stenci.app/privacy-policy"
           class="text-bold text-primary"
           target="_blank"
        >
          https://stenci.app/privacy-policy
        </a>.
      </p>

      <p>
        <strong>10.3.</strong>
        O uso dessa integração está sujeito, adicionalmente, aos
        <a href="https://policies.google.com/terms"
           class="text-bold text-primary"
           target="_blank"
        >Termos de Serviço do Google</a>, sobre os quais a Empresa não possui
        controle nem responsabilidade.
      </p>

      <p>
        <strong>10.4.</strong>
        A Empresa não se responsabiliza por indisponibilidade, alterações,
        interrupções ou descontinuação dos serviços do Google que afetem
        essa funcionalidade.
      </p>

      <p>
        <strong>10.5.</strong>
        O Usuário pode desativar essa integração a qualquer momento, em "Meu
        perfil" na Plataforma ou diretamente nas configurações de segurança
        de sua Conta Google.
      </p>

      <div class="h4 page-subtitle">11. Disponibilidade, suporte e manutenção</div>

      <p>
        <strong>11.1.</strong>
        A Plataforma poderá passar por manutenções programadas para melhorias e
        correções.
      </p>

      <p>
        <strong>11.2.</strong>
        Não há garantia de disponibilidade ininterrupta.
      </p>

      <p>
        <strong>11.3.</strong>
        O suporte será prestado pelos canais e horários definidos pela Empresa.
      </p>

      <div class="h4 page-subtitle">12. Backup, retenção e exportação de dados</div>

      <p>
        <strong>12.1.</strong>
        A Empresa realiza rotinas de backup conforme suas políticas internas.
      </p>

      <p>
        <strong>12.2.</strong>
        Em caso de cancelamento ou inadimplência, os dados permanecerão
        disponíveis para exportação por 60 (sessenta) dias.
      </p>

      <p>
        <strong>12.3.</strong>
        Após esse prazo, os dados poderão ser excluídos de forma definitiva,
        salvo obrigação legal.
      </p>

      <div class="h4 page-subtitle">13. Cancelamento e rescisão</div>

      <p>
        <strong>13.1.</strong>
        O Cliente pode solicitar cancelamento a qualquer momento.
      </p>

      <p>
        <strong>13.2.</strong>
        Pagamentos já realizados não são reembolsáveis, exceto nos casos
        previstos em lei (ex.: direito de arrependimento).
      </p>

      <p>
        <strong>13.3.</strong>
        A Empresa poderá rescindir o contrato em caso de violação destes Termos.
      </p>

      <div class="h4 page-subtitle">14. Limitação de responsabilidade</div>

      <p>
        <strong>14.1.</strong>
        A Plataforma é fornecida “no estado em que se encontra”.
      </p>

      <p>
        <strong>14.2.</strong>
        A Empresa não se responsabiliza por:
      </p>

      <ul>
        <li>decisões clínicas ou administrativas do Cliente;</li>
        <li>falhas de internet, energia ou dispositivos;</li>
        <li>uso indevido da Plataforma;</li>
        <li>serviços de terceiros integrados.</li>
      </ul>

      <p>
        <strong>14.3.</strong>
        Eventual responsabilidade da Empresa fica limitada ao valor pago pelo
        Cliente nos últimos 12 (doze) meses anteriores ao evento.
      </p>

      <div class="h4 page-subtitle">15. Alterações dos termos</div>

      <p>
        A Empresa poderá alterar estes Termos a qualquer tempo. O uso continuado
        da Plataforma após a atualização implica aceitação.
      </p>

      <div class="h4 page-subtitle">16. Lei aplicável e foro</div>

      <p>
        Este Termo é regido pelas leis da República Federativa do Brasil.
        Fica eleito o foro da Comarca de Curitiba/PR, com renúncia a qualquer
        outro.
      </p>

      <p>
        <strong>STENCI TECNOLOGIA LTDA</strong>
        <br />
        CNPJ 52.096.345/0001-94
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsContent',
};
</script>

<style lang="scss">
  @import '@/assets/scss/_variables.scss';

  .terms-content {
    color: $dark-color;
    font-size: $unit-4;
    .terms-content-updated {
      color: $gray-color-dark;
      font-size: $font-size-sm;
    }
    .terms-content-body {
      margin-top: $unit-8;
      .page-subtitle {
        margin: $unit-8 0 $unit-4 0;
      }
    }
  }
</style>
